import '../../styles/web-components/toggle-module.scss';
import '../../styles/templates/_collection-v2.scss';
import { refreshWishlistIcons } from '../services/wishlist.service';
import Splide from "@splidejs/splide";
import { DESKTOP_WIDTH, TABLET_WIDTH } from '../constants/devices.constants';
import { updateArrowPosition } from '../helpers/carousel-utils';
const defaultCarouselOptions = {
    mediaQuery: "min",
    gap: "8px",
    type: 'slide',
    perPage: 2,
    arrows: false,
    pagination: false,
    padding: { right: "5%" },
    breakpoints: {
        [TABLET_WIDTH]: {
            perPage: 3
        },
        [DESKTOP_WIDTH]: {
            perPage: 4,
            gap: "24px",
            arrows: true,
            padding: { right: "0" },
        }
    }
};
class ToggleModule extends HTMLElement {
    static get observedAttributes() {
        return ["selected-cta-index"];
    }
    carousel = null;
    loadingSpinner = null;
    numProducts = +this.getAttribute('num-products') || 6;
    constructor() {
        super();
        this.addEventListener('click', async (e) => {
            const target = e.target;
            if (target.matches(".toggle-module__navigation-item:not(.toggle-module__navigation-item--selected)")) {
                // eslint-disable-next-line wc/no-constructor-attributes
                this.setAttribute('selected-cta-index', target.dataset.ctaIndex);
            }
        });
        window.addEventListener('resize', () => {
            updateArrowPosition(this.carousel);
        });
    }
    connectedCallback() {
        this.loadingSpinner = this.querySelector('loading-spinner');
        this.carousel = new Splide(this.querySelector('.splide'), defaultCarouselOptions);
        this.carousel.mount();
        const firstCta = this.querySelector('.toggle-module__navigation-item');
        if (firstCta) {
            this.fetchAndRenderCollection(firstCta.dataset.ctaIndex);
        }
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (!this.carousel || oldValue === newValue)
            return;
        switch (name) {
            case 'selected-cta-index':
                this.fetchAndRenderCollection(newValue);
                break;
            default:
                break;
        }
    }
    async fetchAndRenderCollection(ctaIndex) {
        console.log('CTA Index:', ctaIndex);
        const contentEl = this.querySelector('.toggle-module__content');
        contentEl?.classList.add('toggle-module__content--loading');
        this.loadingSpinner?.setAttribute('show', 'true');
        try {
            let selectedCta = null;
            this.querySelectorAll('.toggle-module__navigation-item').forEach(c => {
                if (c.dataset.ctaIndex === ctaIndex) {
                    c.classList.add('toggle-module__navigation-item--selected');
                    selectedCta = c;
                }
                else {
                    c.classList.remove('toggle-module__navigation-item--selected');
                }
            });
            if (!selectedCta)
                return;
            const collectionHandle = selectedCta.dataset.collectionHandle;
            const resp = await fetch(`/collections/${collectionHandle}?sections=collection-product-cards`);
            const json = await resp.json();
            const parser = new DOMParser();
            const doc = parser.parseFromString(json['collection-product-cards'], 'text/html');
            const styles = new Set(doc.querySelectorAll('link[rel="stylesheet"]'));
            styles.forEach(style => {
                if (!document.head.querySelector(`link[href="${style.href.replace("https:", "")}"]`)) {
                    document.head.appendChild(style);
                }
            });
            const productList = Array.from(doc.querySelectorAll("product-card")).slice(0, this.numProducts).map(el => {
                const li = document.createElement('li');
                li.className = 'splide__slide';
                li.appendChild(el);
                return li;
            });
            const results = this.querySelector('.splide ul');
            results.replaceChildren(...productList);
            results.dataset.collectionHandle = collectionHandle;
            const firstImg = results.querySelector('img');
            firstImg?.addEventListener('load', () => {
                updateArrowPosition(this.carousel);
            }, { once: true });
            this.carousel?.refresh().go(0);
            refreshWishlistIcons('toggle-module .splide');
        }
        finally {
            contentEl?.classList.remove('toggle-module__content--loading');
            this.loadingSpinner?.setAttribute('show', 'false');
        }
    }
}
if (!window.customElements.get("toggle-module")) {
    customElements.define("toggle-module", ToggleModule);
}
